/**
 * Legacy route helpers for maintaining backward compatibility
 * These routes point to legacy pages that haven't been migrated to React Router 7 yet
 */

export const legacyRoutes = {
  /**
   * Employees area routes
   */
  employees: {
    index: '/Employee/EmployeeOverview',
    details: (employeeId: string | number) =>
      `/Organization/Employee/EditEmployee/${employeeId}`,
  },
  /**
   * Customers area routes
   */
  customers: {
    index: '/CRM/Home',
    details: (customerId: string | number) =>
      `/CRM/Customer/Edit/${customerId}`,
  },
  /**
   * Project Management area routes
   */
  projectManagement: {
    /**
     * Returns the route to the project plan page
     * @param projectId - The project's SourceId
     * @returns The full route path to the project plan
     */
    index: (projectId: string | number) =>
      `/ProjectManagement/Plan/Index/${projectId}`,
    /** Catch-all route pattern for unmatched ProjectManagement paths */
    fallback: '/ProjectManagement/*',
    /**
     * .NET MVC page URLs (for iframe src)
     */
    planning: (projectId: string | number) =>
      `/ProjectManagement/Plan/Index/${projectId}`,
    team: (projectId: string | number) =>
      `/ProjectManagement/Resource/Group/${projectId}`,
    contracts: (projectId: string | number) =>
      `/ProjectManagement/ProjectSubContract/Index/${projectId}`,
    billing: (projectId: string | number) =>
      `/ProjectManagement/Billing/Index/${projectId}`,
    invoices: (projectId: string | number) =>
      `/ProjectManagement/Finance/Invoice/${projectId}`,
    settings: (projectId: string | number) =>
      `/ProjectManagement/Setting/Edit/${projectId}`,
    allExpenses: (projectId: string | number) =>
      `/ProjectManagement/Finance/ProjectAllExpenses/${projectId}`,
    /**
     * Project expense page URLs
     */
    projectExpenses: {
      new: () => '/ProjectManagement/ProjectExpense',
      edit: (expenseId: string | number) =>
        `/ProjectManagement/ProjectExpense/EditProjectExpense/${expenseId}`,
    },
    /**
     * Resource page URLs
     */
    resource: {
      group: (projectId: string | number) =>
        `/ProjectManagement/Resource/Group/${projectId}`,
    },
    /**
     * Sub-contract page URLs
     */
    projectSubContract: {
      index: (projectId: string | number) =>
        `/ProjectManagement/ProjectSubContract/Index/${projectId}`,
      create: (projectId: string | number) =>
        `/ProjectManagement/ProjectSubContract/CreatePage/${projectId}`,
    },
  },
  /**
   * Organization area routes
   */
  organization: {
    employee: {
      /**
       * Legacy Edit Employee page (.NET MVC). Takes the user's UserId.
       */
      edit: (userId: string | number) =>
        `/Organization/Employee/EditEmployee/${userId}`,
      /**
       * Legacy New Employee page (.NET MVC). Gated by the `NewEmployee`
       * permittedPage on /api/userMe — same gate as the Create menu in
       * the top navigation.
       */
      new: '/Organization/Employee/NewEmployee',
    },
  },
  /**
   * Settings area routes
   */
  settings: {
    general: {
      index: '/Settings/General/RootPage',
    },
    invoice: {
      currencySetting: '/Settings/Invoice/CurrencySetting',
    },
  },
  /**
   * Reports area routes
   */
  reports: {
    personal: {
      expenseOverviewReport: '/Reports/Personal/ExpenseOverviewReport',
      expenseReportSubmitPrint: '/Reports/Personal/ExpenseReportSubmitPrint',
    },
  },

  /**
   * Registration area routes
   */
  registration: {
    employeeExpense: {
      new: () => '/Registration/EmployeeExpense',
      edit: (expenseId: string | number) =>
        `/Registration/EmployeeExpense/EditEmployeeExpense/${expenseId}`,
    },
  },
} as const;
